import React, { useState } from "react";
import {
  Grid,
  Typography,
  Button,
  ListItemButton,
  ListItemText,
  OutlinedInput,
} from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import SearchRoundedIcon from "@mui/icons-material/SearchRounded";
import { useDispatch } from "react-redux";

import * as actionTypes from "./state/actionTypes";
import { searchLicenses } from "./state/actions";

const AccountsTable = ({
  licenses,
  currentLicense,
  formik,
  touched,
  setIsConfirmationModalOpen,
  setPendingCurrentLicense,
  error,
}) => {
  const dispatch = useDispatch();
  const [search, setSearch] = useState("");
  const handleItemClick = (e) => {
    if (e.currentTarget.id !== currentLicense.key) {
      if (!touched) {
        if (currentLicense.isNew) dispatch({ type: actionTypes.REMOVE_NEW });
        dispatch({
          type: actionTypes.SET_CURRENT_LICENSE,
          payload: e.currentTarget.id,
        });
      } else {
        setIsConfirmationModalOpen(true);
        setPendingCurrentLicense(e.currentTarget.id);
      }
    }
  };

  const handleAddNew = () => {
    dispatch({ type: actionTypes.ADD_NEW });
  };

  const handleChangeSearch = (e) => {
    setSearch(e.target.value);
    dispatch(searchLicenses(e.target.value, error));
  };

  return (
    <Grid
      container
      alignItems="center"
      direction="column"
      sx={{ minHeight: "600px" }}
    >
      <Grid item container justifyContent="space-between" alignItems="center">
        <Grid item>
          <Typography
            sx={{
              color: "#050D2E",
              fontSize: "1.125rem",
              fontWeight: 550,
              letterSpacing: "-0.6px",
              lineHeight: "21px",
            }}
          >
            Licenses
          </Typography>
        </Grid>
        <Grid item>
          <Button
            startIcon={<AddIcon size="small" />}
            variant="contained"
            disableElevation
            sx={{
              height: "36px",
              border: "1px solid #DBDEE6",
              borderRadius: "4px",
              background: "linear-gradient(180deg, #FFFFFF 0%, #F3F5F7 100%)",
              textTransform: "none",
              color: "#050D2E",
              fontSize: ".875rem",
              fontWeight: 550,
            }}
            onClick={handleAddNew}
            disabled={currentLicense?.isNew}
          >
            Add New
          </Button>
        </Grid>
      </Grid>
      <Grid item xs={12} sx={{ width: "100%" }}>
        <OutlinedInput
          id="search"
          placeholder="Search"
          sx={{
            mt: 2,
            width: "100%",
            height: "40px",
            "& .MuiInputBase-root": { height: "40px" },
            "& .MuiOutlinedInput": { height: "40px" },
          }}
          type="text"
          fullWidth
          value={search}
          onChange={handleChangeSearch}
          endAdornment={
            <SearchRoundedIcon sx={{ color: "#8792AB", fontSize: "1rem" }} />
          }
        />
      </Grid>
      <Grid item sx={{ width: "100%", pt: 2 }}>
        {licenses.map((license) => {
          return (
            <ListItemButton
              key={license.key}
              sx={{
                padding: "8px",
                maxHeight: "36px",
                height: "36px",
                width: "100%",
                "&:hover": { backgroundColor: "#D4EDF3" },
                backgroundColor:
                  currentLicense.key === license.key ? "#D4EDF3" : "#fffff",
                borderRadius: "4px",
              }}
              onClick={handleItemClick}
              id={license.key}
            >
              {license.isNew ? (
                <>
                  <OutlinedInput
                    id={formik.values.uniqueId}
                    sx={{
                      height: "25px",
                      width: "100%",
                      "& .MuiInputBase-root": {
                        height: "25px",
                      },
                      "& .MuiOutlinedInput": {
                        height: "25px",
                      },
                      backgroundColor: "#ffffff",
                    }}
                    value={formik.values.licenseName}
                    onChange={formik.handleChange}
                    error={Boolean(formik.errors.licenseName)}
                    placeholder="License Name"
                    name="licenseName"
                  />
                </>
              ) : (
                <ListItemText
                  sx={{
                    color:
                      currentLicense.key === license.key
                        ? "#1492AF"
                        : "#050D2E",
                    "& .MuiTypography-root": {
                      fontWeight:
                        currentLicense.key === license.key ? "550" : "400",
                    },
                  }}
                >
                  {license.licenseName}
                </ListItemText>
              )}
            </ListItemButton>
          );
        })}
      </Grid>
    </Grid>
  );
};

export default AccountsTable;
